(() => {
  'use strict';

  /*
   * Mahadev Mala – Native Shopify Product Add-ons
   * X-Ray Variant: 49006515716313 – ₹500
   * Silver Pendant Variant: 49006527545561 – ₹1,200
   */

  const XRAY_VARIANT_ID = 49006515716313;
  const SILVER_VARIANT_ID = 49006527545561;

  const XRAY_PRICE = 50000; // Shopify price is stored in paise
  const SILVER_PRICE = 120000;

  const EXCLUDED_HANDLES = [
  'x-ray-certification-add-on',
  '925-silver-pendant-add-on',
  '1-mukhi-underdeveloped-rudraksha'
];

  function getProductHandle() {
    const match = window.location.pathname.match(/^\/products\/([^/]+)/);
    return match ? match[1] : null;
  }

  function formatMoney(amountInPaise) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amountInPaise / 100);
  }

  async function getCurrentProduct() {
    const handle = getProductHandle();

    if (!handle) {
      return null;
    }

    const response = await fetch(`/products/${handle}.js`, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to load product information.');
    }

    return response.json();
  }

  function createAddOnMarkup() {
    const wrapper = document.createElement('div');
    wrapper.id = 'mahadev-product-addons';

    wrapper.innerHTML = `
      <style>
        #mahadev-product-addons {
          margin-block: 22px;
          width: 100%;
        }

        .mahadev-addon-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 14px;
        }

        .mahadev-addon-field {
          min-width: 0;
        }

        .mahadev-addon-field label {
          display: block;
          margin-bottom: 8px;
          font-size: 14px;
          font-weight: 600;
          color: rgb(var(--text-color, 28 28 28));
        }

        .mahadev-addon-field select {
          width: 100%;
          min-height: 52px;
          padding: 12px 40px 12px 14px;
          border: 1px solid rgba(28, 28, 28, 0.25);
          border-radius: 0;
          background: #fff;
          color: #1c1c1c;
          font: inherit;
          cursor: pointer;
        }

        .mahadev-addon-total {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
          margin-top: 18px;
          padding: 16px 0;
          border-top: 1px solid rgba(28, 28, 28, 0.15);
          border-bottom: 1px solid rgba(28, 28, 28, 0.15);
        }

        .mahadev-addon-total__label {
          font-size: 15px;
          font-weight: 600;
        }

        #mahadev-addon-total-price {
          font-size: 21px;
          font-weight: 600;
          white-space: nowrap;
        }

        .mahadev-addon-note {
          margin-top: 9px;
          font-size: 12px;
          opacity: 0.7;
        }

        .mahadev-addon-loading {
          opacity: 0.6;
          pointer-events: none;
        }

        @media screen and (max-width: 699px) {
          .mahadev-addon-grid {
            grid-template-columns: 1fr;
          }
        }
      </style>

      <div class="mahadev-addon-grid">
        <div class="mahadev-addon-field">
          <label for="mahadev-xray-option">X-Ray Certification</label>

          <select id="mahadev-xray-option">
            <option value="no">Without X-Ray Certificate</option>
            <option value="yes">With X-Ray Certificate (+₹500)</option>
          </select>
        </div>

        <div class="mahadev-addon-field">
          <label for="mahadev-silver-option">Style</label>

          <select id="mahadev-silver-option">
            <option value="no">Without Silver Pendant</option>
            <option value="yes">With 925 Silver Pendant (+₹1,200)</option>
          </select>
        </div>
      </div>

      <div class="mahadev-addon-total">
        <span class="mahadev-addon-total__label">Total Price</span>
        <strong id="mahadev-addon-total-price">—</strong>
      </div>

      <p class="mahadev-addon-note">
        Selected add-ons will be added separately to your cart.
      </p>
    `;

    return wrapper;
  }

  function findProductForm() {
    const forms = Array.from(
      document.querySelectorAll('form[action*="/cart/add"]')
    );

    return forms.find((form) => form.querySelector('[name="id"]')) || null;
  }

  function getSelectedVariantId(form) {
    const variantInput = form.querySelector('[name="id"]');

    if (!variantInput) {
      return null;
    }

    return Number(variantInput.value);
  }

  function getQuantity(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? Number(quantityInput.value) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function initialiseAddOns(product, form) {
    if (document.querySelector('#mahadev-product-addons')) {
      return;
    }

    const addOnMarkup = createAddOnMarkup();
    const productFormElement = form.closest('product-form') || form;

    productFormElement.parentNode.insertBefore(
      addOnMarkup,
      productFormElement
    );

    const xraySelect = document.querySelector('#mahadev-xray-option');
    const silverSelect = document.querySelector('#mahadev-silver-option');
    const totalElement = document.querySelector(
      '#mahadev-addon-total-price'
    );

    function findVariant() {
      const selectedVariantId = getSelectedVariantId(form);

      return (
        product.variants.find(
          (variant) => Number(variant.id) === selectedVariantId
        ) ||
        product.variants[0] ||
        null
      );
    }

    function updateTotal() {
      const variant = findVariant();

      if (!variant) {
        totalElement.textContent = 'Unavailable';
        return;
      }

      let total = Number(variant.price);

      if (xraySelect.value === 'yes') {
        total += XRAY_PRICE;
      }

      if (silverSelect.value === 'yes') {
        total += SILVER_PRICE;
      }

      totalElement.textContent = formatMoney(total);
    }

    xraySelect.addEventListener('change', updateTotal);
    silverSelect.addEventListener('change', updateTotal);

    document.addEventListener('change', updateTotal);

    let lastVariantId = getSelectedVariantId(form);

    const variantWatcher = window.setInterval(() => {
      if (!document.body.contains(form)) {
        window.clearInterval(variantWatcher);
        return;
      }

      const currentVariantId = getSelectedVariantId(form);

      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        updateTotal();
      }
    }, 300);

    updateTotal();

    document.addEventListener(
      'submit',
      async (event) => {
        const submittedForm = event.target;

       if (
  !(submittedForm instanceof HTMLFormElement) ||
  !submittedForm.matches('form[action*="/cart/add"]') ||
  !submittedForm.querySelector('[name="id"]')
) {
  return;
}

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

       const mainVariantId = getSelectedVariantId(submittedForm);

        if (!mainVariantId) {
          window.alert('Please select an available Rudraksha size.');
          return;
        }

        const quantity = getQuantity(submittedForm);
        const orderGroup = `MM-${Date.now()}`;

        const items = [
          {
            id: mainVariantId,
            quantity,
            properties: {
              '_Mahadev order group': orderGroup
            }
          }
        ];

        if (xraySelect.value === 'yes') {
          items.push({
            id: XRAY_VARIANT_ID,
            quantity,
            properties: {
              '_Add-on for': product.title,
              '_Mahadev order group': orderGroup
            }
          });
        }

        if (silverSelect.value === 'yes') {
          items.push({
            id: SILVER_VARIANT_ID,
            quantity,
            properties: {
              '_Add-on for': product.title,
              '_Mahadev order group': orderGroup
            }
          });
        }

        addOnMarkup.classList.add('mahadev-addon-loading');

        const submitButtons = form.querySelectorAll(
          'button[type="submit"], input[type="submit"]'
        );

        submitButtons.forEach((button) => {
          button.disabled = true;
        });

        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items })
            }
          );

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));

            throw new Error(
              errorData.description ||
                errorData.message ||
                'Products could not be added to cart.'
            );
          }

          window.location.href = '/cart';
        } catch (error) {
          console.error('Mahadev add-on error:', error);
          window.alert(
            error.message ||
              'Something went wrong while adding the products.'
          );

          addOnMarkup.classList.remove('mahadev-addon-loading');

          submitButtons.forEach((button) => {
            button.disabled = false;
          });
        }
      },
      true
    );
  }

 async function start() {
  const handle = getProductHandle();

  if (!handle || EXCLUDED_HANDLES.includes(handle)) {
    return;
  }

  try {
    const product = await getCurrentProduct();

    let attempts = 0;

    const formFinder = window.setInterval(() => {
      attempts += 1;

      const form = findProductForm();

      if (form) {
        window.clearInterval(formFinder);
        initialiseAddOns(product, form);
      }

      if (attempts >= 40) {
        window.clearInterval(formFinder);
      }
    }, 250);
  } catch (error) {
    console.error('Mahadev product add-ons failed:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
})();